<div class="rep-dashboard container mt-2">
  <!-- Hero Section - jen text -->
  <div class="dashboard-hero">
    <div class="container-fluid">
      <h3 class="hero-title mb-1 text-center mb-0">
        <i class="bi bi-lightning-charge me-2"></i>{{ 'dashboard.title' | translate }}
      </h3>
    </div>
  </div>

  <div class="mt-2">
    <!-- Quick Actions -->
    <div class="row mb-4">
      <div class="col-md-6 col-lg-4 mb-3 pe-lg-2">
        <div class="feature-card" (click)="createReservation()">
          <div class="feature-icon">
            <i class="bi bi-ev-station"></i>
          </div>
          <h5>{{ 'dashboard.action_new_reservation' | translate }}</h5>
          <p class="text-muted mb-0">{{ 'dashboard.action_new_reservation_text' | translate }}</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mb-3 pe-lg-2">
        <div class="feature-card" (click)="viewReservations()">
          <div class="feature-icon icon-info">
            <i class="bi bi-list-ul"></i>
          </div>
          <h5>{{ 'dashboard.action_my_reservations' | translate }}</h5>
          <p class="text-muted mb-0">{{ 'dashboard.action_my_reservations_text' | translate }}</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mb-3">
        <div class="feature-card">
          <div class="feature-icon icon-success">
            <i class="bi bi-tree"></i>
          </div>
          <h5>{{ 'dashboard.action_eco' | translate }}</h5>
          <p class="text-muted mb-0">{{ 'dashboard.action_eco_text' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Reservations -->
    <div class="row" *ngIf="dataReady">
      <div class="col-lg-6 mb-4 pe-lg-2">
        <div class="card">
          <div class="rep-card-header">
            <i class="bi bi-calendar-day me-2"></i>{{ 'dashboard.today' | translate }}
          </div>
          <div class="card-body">
            <div *ngIf="todayReservations.length === 0" class="empty-state">
              <i class="bi bi-calendar-x"></i>
              <p>{{ 'dashboard.today_empty' | translate }}</p>
            </div>
            <div *ngIf="todayReservations.length > 0">
              <div *ngFor="let res of todayReservations" class="reservation-item" (click)="viewReservation(res.id_reservation!)">
                <div>
                  <strong><i class="bi bi-clock text-warning me-2"></i>{{ formatTime(res.date_from) }} - {{ formatTime(res.date_to!) }}</strong>
                  <div class="text-muted small">{{ res.location_name }} - {{ res.station_name }}</div>
                </div>
                <div class="text-end">
                  <span class="badge bg-primary">{{ res.energy_kwh }} kWh</span>
                  <div class="small text-muted">{{ res.license_plate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card">
          <div class="rep-card-header header-info">
            <i class="bi bi-clock-history me-2"></i>{{ 'dashboard.upcoming' | translate }}
          </div>
          <div class="card-body">
            <div *ngIf="upcomingReservations.length === 0" class="empty-state">
              <i class="bi bi-calendar-check"></i>
              <p>{{ 'dashboard.upcoming_empty' | translate }}</p>
              <button class="btn btn-accent btn-sm" (click)="createReservation()">{{ 'dashboard.create_reservation_btn' | translate }}</button>
            </div>
            <div *ngIf="upcomingReservations.length > 0">
              <div *ngFor="let res of upcomingReservations" class="reservation-item" (click)="viewReservation(res.id_reservation!)">
                <div>
                  <strong><i class="bi bi-calendar text-info me-2"></i>{{ formatDateTime(res.date_from) }}</strong>
                  <div class="text-muted small">{{ res.location_name }} - {{ res.station_name }}</div>
                </div>
                <div class="text-end">
                  <span class="badge bg-info">{{ res.energy_kwh }} kWh</span>
                  <div class="small text-muted">{{ res.license_plate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Statistics -->
    <div class="row" *ngIf="dataReady">
      <div class="col-md-4 mb-3 pe-md-2">
        <div class="stat-card">
          <div class="stat-icon"><i class="bi bi-lightning-charge"></i></div>
          <div>
            <div class="stat-value">{{ totalReservations }}</div>
            <div class="stat-label">{{ 'dashboard.stat_total' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3 pe-md-2">
        <div class="stat-card">
          <div class="stat-icon icon-success"><i class="bi bi-check-circle"></i></div>
          <div>
            <div class="stat-value">{{ completedReservations }}</div>
            <div class="stat-label">{{ 'dashboard.stat_completed' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <div class="stat-card">
          <div class="stat-icon icon-info"><i class="bi bi-calendar-range"></i></div>
          <div>
            <div class="stat-value">{{ upcomingCount }}</div>
            <div class="stat-label">{{ 'dashboard.stat_upcoming' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
